import {app} from '../../app';
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import {UniqueIdService} from "../../services/UniqueIdService";
import {RadioSharedQuestion} from "../../sharedQuestions/RadioSharedQuestion";
import {RateSharedQuestion} from "../../sharedQuestions/RateSharedQuestion";

/**
 * Meta: {
 *  scale: {
 *      from:number, (always 1)
 *      to:number
 *  },
 *  style:'default',
 *  default:number,
 * }
 */
export class RateQuestionComponent {

    protected scope: ng.IScope;
    protected sharedQuestionService:SharedQuestionService;
    protected sessionService:ISessionService;

    sharedQuestion:RateSharedQuestion;

    question:IQuestion;
    nextQuestionCallback;
    value:number;

    private previousValue:number;

    max:number = 5;

    static $inject = ['$scope', 'SharedQuestionService', 'SessionService'];

    constructor($scope: ng.IScope, sharedQuestionService:SharedQuestionService, sessionService:ISessionService) {
        this.scope = $scope;
        this.sharedQuestionService = sharedQuestionService;
        this.sessionService = sessionService;
    }

    public $onInit = () => {
        this.sharedQuestion = new RateSharedQuestion();

        this.setup();
    };

    setup() {
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        if (this.question.meta.scale && isFinite(this.question.meta.scale.to)) {
            this.max = this.question.meta.scale.to;
        }

        let defaultValue = this.question.meta.default;
        if (defaultValue) {
            this.value = parseInt(defaultValue);
            this.update();
        }

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0) {
            this.value = answer.values[0].value;
            this.update();
        }
    }

    public update() {
        let newValue:IValue = {
            value: this.value
        };

        this.sharedQuestion.setValue(newValue);

        // if second click
        if (this.previousValue && this.value === this.previousValue) {
            if (this.sharedQuestionService.questions.length === 1) {
                this.nextQuestionCallback();
            }
        }

        // if first click
        this.previousValue = this.value;
    }

}

app.component('rateQuestion', {
    templateUrl: 'templates/components/questionTypes/rateQuestion.html',
    controller: RateQuestionComponent,
    controllerAs: 'rateQuestion',
    bindings: {
        question: '<',
        nextQuestionCallback: '&'
    }
});